__turbopack_context__.v({
  "className": "caveat_d28bd4a6-module__5xZbha__className",
});
